module.exports = __webpack_public_path__ + "static/media/rocks2.4a68684f.png";